import { render, staticRenderFns } from "./vx.vue?vue&type=template&id=43b65406&scoped=true"
import script from "./vx.vue?vue&type=script&lang=js"
export * from "./vx.vue?vue&type=script&lang=js"
import style0 from "./vx.vue?vue&type=style&index=0&id=43b65406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b65406",
  null
  
)

export default component.exports